import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class NextStepsRoute extends Route {
  mainLayout = MainLayout;

  @service store;

  model() {
    let registration = this.modelFor('registration');

    return {
      organization: registration.get('organization'),
      registration,
    };
  }
}
